import { putApiGalaxyServer } from 'services';
import ApiClientManager from 'core/apiClient';

export interface ConfigureIntegrationV2Payload {
  targetServiceId: number;
  configureWithV2Modal: boolean;
  serviceName: string;
  /** Optional tenant for header override */
  tenant?: string;
  /** Optional realmId for header override */
  realmId?: string;
}

export interface ConfigureIntegrationV2SuccessResponse {
  message: string;
}

export interface ConfigureIntegrationV2ErrorResponse {
  error: string;
  message: string;
  statusCode: number;
}

export const configureIntegrationV2 = ({
  params,
  token,
  config = {},
}: BaseApiParams<ConfigureIntegrationV2Payload>) => {
  // Build custom headers if tenant/realmId are provided to override global cache
  const customHeaders =
    params.tenant && params.realmId
      ? ApiClientManager.buildUrlHeaders({ tenantName: params.tenant, realmId: params.realmId })
      : undefined;

  // Remove header-only fields from the request body
  const { tenant: _tenant, realmId: _realmId, ...bodyParams } = params;

  return putApiGalaxyServer<
    Omit<ConfigureIntegrationV2Payload, 'tenant' | 'realmId'>,
    ConfigureIntegrationV2SuccessResponse
  >(
    `/realm/configureIntegrationV2`,
    bodyParams,
    { ...config, ...(customHeaders && { headers: customHeaders }) },
    token,
  );
};
